export const Radio = {
  parts: ['control', 'label'],
  baseStyle: {
    fontFamily: 'body',
    control: {
      _disabled: {
        bg: '#E2E4E5',
      },
    },
    label: {
      _disabled: {
        opacity: '1',
      },
    },
  },
};
